(function() {
  'use strict';

  function initProductCardSwatches() {
    // Handle swatch clicks
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-swatch-button]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var card = btn.closest('[data-product-card]');
      if (!card) return;

      var swatchContainer = btn.closest('[data-product-card-swatches]');
      if (!swatchContainer) return;

      // Update active state
      var allSwatches = swatchContainer.querySelectorAll('[data-swatch-button]');
      allSwatches.forEach(function(s) { s.classList.remove('product-item-inline-swatch--active'); });
      btn.classList.add('product-item-inline-swatch--active');

      // Swap product card image
      var variantImage = btn.getAttribute('data-variant-image');
      if (variantImage) {
        var imgWrapper = card.querySelector('.product-item__image');
        if (imgWrapper) {
          var img = imgWrapper.querySelector('img');
          if (img) {
            img.setAttribute('src', variantImage);
            img.setAttribute('srcset', variantImage + ' 600w');
          }
        }
      }

      // Store the selected variant ID on the card
      var variantId = btn.getAttribute('data-variant-id');
      if (variantId) {
        card.setAttribute('data-selected-variant-id', variantId);

        var selectedVariantButtonText = card.getAttribute('data-selected-variant-button-text') || 'Add to cart';
        var quickShopTriggers = card.querySelectorAll('[data-quick-shop-trigger]');
        quickShopTriggers.forEach(function(trigger) {
          // Only update the desktop text button. The mobile button's direct
          // child span contains the cart icon and must remain untouched.
          var text = trigger.classList.contains('product-item__quick-view--hoverless')
            ? null
            : trigger.querySelector(':scope > span');
          if (text) text.textContent = selectedVariantButtonText;
          trigger.setAttribute('title', selectedVariantButtonText);
        });
      }
    });

    // Intercept quick-view/quick-add button clicks on cards with a selected variant
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-quick-shop-trigger]');
      if (!trigger) return;

      var card = trigger.closest('[data-product-card]');
      if (!card) return;

      var selectedVariantId = card.getAttribute('data-selected-variant-id');
      if (!selectedVariantId) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      trigger.classList.add('loading');

      // 1. Add to cart using Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(selectedVariantId), quantity: 1 }] })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        trigger.classList.remove('loading');

        // 2. Tell the theme a product was added (refreshes cart count + quick cart content)
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));

        // 3. After the theme has refreshed, click the cart icon to open quick cart
        //    This uses the theme's own click handler which calls r$1("quick-cart:open")
        setTimeout(function() {
          var cartIcon = document.querySelector('[data-js-cart-icon]');
          if (cartIcon) {
            cartIcon.click();
          }
        }, 600);
      })
      .catch(function() {
        trigger.classList.remove('loading');
      });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCardSwatches);
  } else {
    initProductCardSwatches();
  }
})();
